import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fffcfc' },
    '2': { value: '#fff8f7' },
    '3': { value: '#feebe7' },
    '4': { value: '#ffdcd3' },
    '5': { value: '#ffcdc2' },
    '6': { value: '#fdbdaf' },
    '7': { value: '#f5a898' },
    '8': { value: '#ec8e7b' },
    '9': { value: '#e54d2e' },
    '10': { value: '#dd4425' },
    '11': { value: '#d13415' },
    '12': { value: '#5c271f' },
    a1: { value: '#ff000003' },
    a2: { value: '#ff200008' },
    a3: { value: '#f52b0018' },
    a4: { value: '#ff35002c' },
    a5: { value: '#ff2e003d' },
    a6: { value: '#f92d0050' },
    a7: { value: '#e7280067' },
    a8: { value: '#db250084' },
    a9: { value: '#df2600d1' },
    a10: { value: '#d72400da' },
    a11: { value: '#cd2200ea' },
    a12: { value: '#460900e0' },
  },
  dark: {
    '1': { value: '#181111' },
    '2': { value: '#1f1513' },
    '3': { value: '#391714' },
    '4': { value: '#4e1511' },
    '5': { value: '#5e1c16' },
    '6': { value: '#6e2920' },
    '7': { value: '#853a2d' },
    '8': { value: '#ac4d39' },
    '9': { value: '#e54d2e' },
    '10': { value: '#ec6142' },
    '11': { value: '#ff977d' },
    '12': { value: '#fbd3cb' },
    a1: { value: '#f1121208' },
    a2: { value: '#ff55330f' },
    a3: { value: '#ff35232b' },
    a4: { value: '#fd201142' },
    a5: { value: '#fe332153' },
    a6: { value: '#ff4f3864' },
    a7: { value: '#fd644a7d' },
    a8: { value: '#fe6d4ea7' },
    a9: { value: '#fe5431e4' },
    a10: { value: '#ff6847eb' },
    a11: { value: '#ff977d' },
    a12: { value: '#ffd6cefb' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.tomato.light.1}', _dark: '{colors.tomato.dark.1}' } },
  '2': { value: { _light: '{colors.tomato.light.2}', _dark: '{colors.tomato.dark.2}' } },
  '3': { value: { _light: '{colors.tomato.light.3}', _dark: '{colors.tomato.dark.3}' } },
  '4': { value: { _light: '{colors.tomato.light.4}', _dark: '{colors.tomato.dark.4}' } },
  '5': { value: { _light: '{colors.tomato.light.5}', _dark: '{colors.tomato.dark.5}' } },
  '6': { value: { _light: '{colors.tomato.light.6}', _dark: '{colors.tomato.dark.6}' } },
  '7': { value: { _light: '{colors.tomato.light.7}', _dark: '{colors.tomato.dark.7}' } },
  '8': { value: { _light: '{colors.tomato.light.8}', _dark: '{colors.tomato.dark.8}' } },
  '9': { value: { _light: '{colors.tomato.light.9}', _dark: '{colors.tomato.dark.9}' } },
  '10': { value: { _light: '{colors.tomato.light.10}', _dark: '{colors.tomato.dark.10}' } },
  '11': { value: { _light: '{colors.tomato.light.11}', _dark: '{colors.tomato.dark.11}' } },
  '12': { value: { _light: '{colors.tomato.light.12}', _dark: '{colors.tomato.dark.12}' } },
  a1: { value: { _light: '{colors.tomato.light.a1}', _dark: '{colors.tomato.dark.a1}' } },
  a2: { value: { _light: '{colors.tomato.light.a2}', _dark: '{colors.tomato.dark.a2}' } },
  a3: { value: { _light: '{colors.tomato.light.a3}', _dark: '{colors.tomato.dark.a3}' } },
  a4: { value: { _light: '{colors.tomato.light.a4}', _dark: '{colors.tomato.dark.a4}' } },
  a5: { value: { _light: '{colors.tomato.light.a5}', _dark: '{colors.tomato.dark.a5}' } },
  a6: { value: { _light: '{colors.tomato.light.a6}', _dark: '{colors.tomato.dark.a6}' } },
  a7: { value: { _light: '{colors.tomato.light.a7}', _dark: '{colors.tomato.dark.a7}' } },
  a8: { value: { _light: '{colors.tomato.light.a8}', _dark: '{colors.tomato.dark.a8}' } },
  a9: { value: { _light: '{colors.tomato.light.a9}', _dark: '{colors.tomato.dark.a9}' } },
  a10: { value: { _light: '{colors.tomato.light.a10}', _dark: '{colors.tomato.dark.a10}' } },
  a11: { value: { _light: '{colors.tomato.light.a11}', _dark: '{colors.tomato.dark.a11}' } },
  a12: { value: { _light: '{colors.tomato.light.a12}', _dark: '{colors.tomato.dark.a12}' } },
  default: { value: { _light: '{colors.tomato.light.9}', _dark: '{colors.tomato.dark.9}' } },
  emphasized: { value: { _light: '{colors.tomato.light.10}', _dark: '{colors.tomato.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.tomato.light.a11}', _dark: '{colors.tomato.dark.a11}' } },
})

export default {
  name: 'tomato',
  tokens,
  semanticTokens,
}
